var map = {
	"./2fa-login/mail_icon.svg": "f7af",
	"./2fa-login/shield.svg": "3750",
	"./3rd-party-logos/meitav.svg": "7919",
	"./action-list/action-list.svg": "b97d",
	"./animations/Check": "c894",
	"./animations/Check.json": "c894",
	"./animations/Expense": "7f96",
	"./animations/Expense.json": "7f96",
	"./animations/Expense_V2": "4271",
	"./animations/Expense_V2.json": "4271",
	"./animations/Income": "cd3b",
	"./animations/Income.json": "cd3b",
	"./animations/MonthlySaving": "df7b",
	"./animations/MonthlySaving.json": "df7b",
	"./animations/OpportunisticSaving": "ee05",
	"./animations/OpportunisticSaving.json": "ee05",
	"./animations/action-list": "691b",
	"./animations/action-list-cellebration": "28e4",
	"./animations/action-list-cellebration.json": "28e4",
	"./animations/action-list.json": "691b",
	"./animations/broken": "2796",
	"./animations/broken.json": "2796",
	"./animations/car": "5edb",
	"./animations/car.json": "5edb",
	"./animations/cashflow-intro": "a421",
	"./animations/cashflow-intro.json": "a421",
	"./animations/challenge-insight": "96fe",
	"./animations/challenge-insight.json": "96fe",
	"./animations/challenge-popup": "7a30",
	"./animations/challenge-popup.json": "7a30",
	"./animations/donation": "6e6c",
	"./animations/donation.json": "6e6c",
	"./animations/economy-negative-balance": "5ed5",
	"./animations/economy-negative-balance.json": "5ed5",
	"./animations/economy-positive-balance": "1f50",
	"./animations/economy-positive-balance.json": "1f50",
	"./animations/financial-advice": "a721",
	"./animations/financial-advice.json": "a721",
	"./animations/fixed-expense-decreased": "12ea",
	"./animations/fixed-expense-decreased.json": "12ea",
	"./animations/fixed-expense-increased": "a69d",
	"./animations/fixed-expense-increased.json": "a69d",
	"./animations/fixed-income-decreased": "2137",
	"./animations/fixed-income-decreased.json": "2137",
	"./animations/fixed-income-increased": "fa9c",
	"./animations/fixed-income-increased.json": "fa9c",
	"./animations/forward-looking": "5956",
	"./animations/forward-looking.json": "5956",
	"./animations/jumping-graph": "33cd",
	"./animations/jumping-graph.json": "33cd",
	"./animations/leisure": "db53",
	"./animations/leisure.json": "db53",
	"./animations/loader": "d520",
	"./animations/loader-arrows": "59567",
	"./animations/loader-arrows.json": "59567",
	"./animations/loader-pyramid": "d514",
	"./animations/loader-pyramid.json": "d514",
	"./animations/loader-sun": "2d21",
	"./animations/loader-sun.json": "2d21",
	"./animations/loader-wavy-line": "c1f6",
	"./animations/loader-wavy-line.json": "c1f6",
	"./animations/loader.json": "d520",
	"./animations/might-be-fixed-expense": "efe8",
	"./animations/might-be-fixed-expense.json": "efe8",
	"./animations/might-be-fixed-income": "f7c6",
	"./animations/might-be-fixed-income.json": "f7c6",
	"./animations/new-skeleton-loader": "6d9a",
	"./animations/new-skeleton-loader.json": "6d9a",
	"./animations/one-number": "bef4",
	"./animations/one-number.json": "bef4",
	"./animations/osh-balance": "b811",
	"./animations/osh-balance.json": "b811",
	"./animations/other": "fbee",
	"./animations/other.json": "fbee",
	"./animations/pets": "8f7e",
	"./animations/pets.json": "8f7e",
	"./animations/pharma": "2eb3",
	"./animations/pharma.json": "2eb3",
	"./animations/rising-sun": "b732",
	"./animations/rising-sun.json": "b732",
	"./animations/rolling-credit": "ddb6",
	"./animations/rolling-credit-vis.svg": "1ac0",
	"./animations/rolling-credit.json": "ddb6",
	"./animations/security": "f5cf",
	"./animations/security.json": "f5cf",
	"./animations/seesaw": "b5c7",
	"./animations/seesaw.json": "b5c7",
	"./animations/shopping": "31c8",
	"./animations/shopping.json": "31c8",
	"./animations/success": "30a5",
	"./animations/success.json": "30a5",
	"./animations/take-outs": "5d18",
	"./animations/take-outs.json": "5d18",
	"./animations/tourism": "bd17",
	"./animations/tourism.json": "bd17",
	"./animations/transport": "6aa9",
	"./animations/transport.json": "6aa9",
	"./animations/yahavCredsConnectedSuccess": "47c4",
	"./animations/yahavCredsConnectedSuccess.json": "47c4",
	"./animations/yahavIsBack": "084a",
	"./animations/yahavIsBack.json": "084a",
	"./animations/zero-balance-expense": "ab79",
	"./animations/zero-balance-expense.json": "ab79",
	"./animations/zero-balance-income": "30cd",
	"./animations/zero-balance-income.json": "30cd",
	"./bank-logos-30/CCAMX45.png": "b1b4",
	"./bank-logos-30/CCCal45.png": "8957",
	"./bank-logos-30/CCIsracard45.png": "7fa3",
	"./bank-logos-30/CCLeumi45.png": "f8d6",
	"./bank-logos-30/Yahav45.png": "f8c0",
	"./bank-logos-30/discount.svg": "2b32",
	"./bank-logos-30/doar.svg": "1562",
	"./bank-logos-30/egud.svg": "2ea7",
	"./bank-logos-30/habeinleumi.svg": "37c7",
	"./bank-logos-30/hapoalim.svg": "4171",
	"./bank-logos-30/leumi.svg": "d191",
	"./bank-logos-30/massad.svg": "ebc9",
	"./bank-logos-30/mercantile.png": "072a",
	"./bank-logos-30/mizrachi.svg": "c2ee",
	"./bank-logos-30/otsar.png": "ccf8",
	"./bank-logos-30/pagi.png": "3f54",
	"./bank-logos-30/pepper-large.svg": "eba3",
	"./bank-logos-30/ubank.png": "f8a7",
	"./bank-logos-45/BankPoalim45.png": "3960",
	"./bank-logos-45/CCAMX45.png": "dfe1",
	"./bank-logos-45/CCCal45.png": "45ec",
	"./bank-logos-45/CCIsracard45.png": "3f1f",
	"./bank-logos-45/CCLeumi45.png": "89d3",
	"./bank-logos-45/Discount45.png": "537f",
	"./bank-logos-45/Doar45.png": "906b",
	"./bank-logos-45/Egood45.png": "3a1d",
	"./bank-logos-45/Habenleumi45.png": "f7c3",
	"./bank-logos-45/Hayal45.png": "ee41",
	"./bank-logos-45/Jerusalem45.png": "e3fa",
	"./bank-logos-45/Leumi45.png": "19b1",
	"./bank-logos-45/Masad45.png": "df06",
	"./bank-logos-45/Mercantil45.png": "aba9",
	"./bank-logos-45/Mizrahi45.png": "a718",
	"./bank-logos-45/Pegi45.png": "f2a0",
	"./bank-logos-45/Pepper45.png": "a33f",
	"./bank-logos-45/UBank45.png": "3c1d",
	"./bank-logos-45/Yahav45.png": "beeb",
	"./bank-logos/amex-large.svg": "c55a",
	"./bank-logos/amex-stacked.png": "346c",
	"./bank-logos/amex-stacked.svg": "e2f7",
	"./bank-logos/amex.jpg": "766c",
	"./bank-logos/cal-diners-stacked.png": "4514",
	"./bank-logos/cal-diners-stacked.svg": "3c6a",
	"./bank-logos/cal-diners.png": "3621",
	"./bank-logos/cal-stacked.png": "be37",
	"./bank-logos/cal.jpg": "583b",
	"./bank-logos/discount-large.svg": "1d0a",
	"./bank-logos/discount-small.svg": "79f8",
	"./bank-logos/discount.jpg": "4511",
	"./bank-logos/doar-large.svg": "c5cd",
	"./bank-logos/doar-small.svg": "0783",
	"./bank-logos/doar.jpg": "e7ed",
	"./bank-logos/egud.jpg": "7b57",
	"./bank-logos/habeinleumi-large.svg": "ab7d",
	"./bank-logos/habeinleumi-small.svg": "7ac4",
	"./bank-logos/habenleumi.jpg": "c6b0",
	"./bank-logos/hapoalim-large.svg": "d4ce",
	"./bank-logos/hapoalim-small.svg": "a473",
	"./bank-logos/igud-large.svg": "6bec",
	"./bank-logos/igud-small.svg": "551e",
	"./bank-logos/isracard-large.svg": "fbec",
	"./bank-logos/isracard-stacked.svg": "d1f8",
	"./bank-logos/isracard.jpg": "c8d2",
	"./bank-logos/jerusalem-large.jpg": "71d9",
	"./bank-logos/jerusalem.jpg": "8af7",
	"./bank-logos/leumi-large.svg": "bdb6",
	"./bank-logos/leumi-obk-small.svg": "e3ad",
	"./bank-logos/leumi-redirect-info-icon.svg": "ba0f",
	"./bank-logos/leumi-small.svg": "1031",
	"./bank-logos/leumi.jpg": "81cc",
	"./bank-logos/leumicard-max-stacked.png": "4048",
	"./bank-logos/leumicard-max.png": "356f",
	"./bank-logos/leumicard-stacked.png": "6693",
	"./bank-logos/leumicard.jpg": "aa7b",
	"./bank-logos/masad.jpg": "cc52",
	"./bank-logos/massad-large.svg": "d1d6",
	"./bank-logos/massad-small.svg": "2acf",
	"./bank-logos/max-leumi-stacked.svg": "b445",
	"./bank-logos/mercantil.jpg": "10b7",
	"./bank-logos/mercantile-large.png": "da94",
	"./bank-logos/mercantile-small@3x.jpg": "c310",
	"./bank-logos/mizrachi-large.svg": "9f7f",
	"./bank-logos/mizrachi-small.svg": "ec1e",
	"./bank-logos/mizrahi.jpg": "7f17",
	"./bank-logos/otsar-large.jpg": "2649",
	"./bank-logos/otsar-large.png": "f708",
	"./bank-logos/otzarhahayal.jpg": "e326",
	"./bank-logos/pagi-large.png": "7c8f",
	"./bank-logos/pagi.jpg": "d13a",
	"./bank-logos/pepper-badge-large.svg": "5ee0",
	"./bank-logos/pepper-large.svg": "5a01",
	"./bank-logos/pepper-redirect-info-icon.svg": "ee94",
	"./bank-logos/pepper.png": "1c10",
	"./bank-logos/poalim.jpg": "5817",
	"./bank-logos/ubank-large.png": "e612",
	"./bank-logos/ubank.jpg": "cd0a",
	"./bank-logos/yahav-large.jpg": "d504",
	"./bank-logos/yahav-new-large.png": "eb5f",
	"./bank-logos/yahav.jpg": "a85b",
	"./benefit.svg": "d27d",
	"./blue-pencil.svg": "4703",
	"./blue-x.svg": "3c32",
	"./bot.png": "9ded",
	"./botprofile@3x.jpg": "85d7",
	"./bubble-left.svg": "ea9c",
	"./bubble-right.svg": "6238",
	"./cards/amex.png": "7543",
	"./cards/cal.png": "a8d5",
	"./cards/diners_visacal.png": "8c29",
	"./cards/isracard.png": "34e0",
	"./cards/leumicard.png": "d175",
	"./cc-example.svg": "6bc5",
	"./celebration/lessnegative": "c4b1",
	"./celebration/lessnegative.json": "c4b1",
	"./celebration/lessnegative.svg": "d473",
	"./celebration/onepositive": "3c6c",
	"./celebration/onepositive.json": "3c6c",
	"./celebration/onepositive.svg": "c74f",
	"./celebration/turnover": "6ce2",
	"./celebration/turnover.json": "6ce2",
	"./celebration/turnover.svg": "08fa",
	"./celebration/xmonthspositive": "0f94",
	"./celebration/xmonthspositive.json": "0f94",
	"./celebration/xmonthspositive.svg": "c698",
	"./challenge/active-challenge.svg": "7ee7",
	"./challenges/onthemap2022.svg": "4301",
	"./check-green-happy.svg": "2e88",
	"./check-mark.svg": "57ad",
	"./check-with-green-circle.svg": "65e7",
	"./churn/churn-icon.svg": "7d65",
	"./close-toaster.svg": "8244",
	"./comments.svg": "f7e7",
	"./crown.png": "370f",
	"./cx-avatars/guy-avatar@3x.png": "7cae",
	"./cx-avatars/nofar-avatar@3x.png": "a8e9",
	"./cx-avatars/yael-avatar@3x.png": "026d",
	"./demo/group.png": "5f73",
	"./demo/one_number.png": "ce5f",
	"./demo/prev_months.png": "47aaf",
	"./demo/slide-1-image@3x.jpg": "7b1d",
	"./demo/slide-2-image@3x.jpg": "8ea9",
	"./demo/slide-3-image@3x.jpg": "76d0",
	"./demo/slide-4-image@3x.jpg": "6aa99",
	"./demo/transactions.png": "2a37",
	"./discount-benefit.svg": "427c",
	"./discount-riseup-friends.svg": "20ae",
	"./dynamic-deposit/authenticated-shapes.svg": "57b4",
	"./dynamic-deposit/celebrate": "1b16",
	"./dynamic-deposit/celebrate-share.svg": "0a3c",
	"./dynamic-deposit/celebrate.json": "1b16",
	"./dynamic-deposit/error-page.svg": "3cf3",
	"./dynamic-deposit/non-authenticated-shapes.svg": "3e73",
	"./dynamic-deposit/progress-bar/authentication.svg": "435c",
	"./dynamic-deposit/progress-bar/choose-amount.svg": "bde6",
	"./dynamic-deposit/progress-bar/detailes.svg": "9295",
	"./dynamic-deposit/progress-bar/signature.svg": "c9f8",
	"./dynamic-deposit/shapes.svg": "588e",
	"./emails/fb-icon.png": "4595",
	"./emails/fb-icon.svg": "2076",
	"./emails/instagram-icon.png": "1e93",
	"./emails/instagram-icon.svg": "d384",
	"./emails/logo.png": "973b",
	"./emails/logo.svg": "c051",
	"./emails/mail_top_image.png": "f06f",
	"./emails/maimon_vid.gif": "4bf1",
	"./emails/twitter-icon.png": "692f",
	"./emails/twitter-icon.svg": "ff1b",
	"./emails/youtube-icon.png": "3613",
	"./emails/youtube-icon.svg": "69cb",
	"./error_icon.svg": "5c67",
	"./exceeding-variables-bar.svg": "87a0",
	"./exclamation-mark@3x.png": "7ab3",
	"./eye.svg": "83a4",
	"./eye_blue.svg": "044b",
	"./fb-icon.svg": "3b33",
	"./fonts/GretaSansH-L-Bold.otf": "9321",
	"./fonts/Pauza-Bold.otf": "2ed2",
	"./fonts/SimplerPro_Alte-Black.otf": "60c2",
	"./fonts/SimplerPro_V3-Bold.otf": "a927",
	"./fonts/SimplerPro_V3-Regular.otf": "49869",
	"./goal-circle-disabled.svg": "60ce",
	"./goal-circle.svg": "b2a4",
	"./grey-pencil.svg": "89db",
	"./group-7@3x.png": "ee2d",
	"./group-cx@3x.png": "8790",
	"./group@3x.jpg": "1dd5",
	"./half-round-header-background.svg": "5bb0",
	"./help-outline@3x.png": "48e1",
	"./hero-image@3x.png": "278b",
	"./hero-login.svg": "1b2c",
	"./how-much.png": "e7dd",
	"./ic-chevron-left-black.svg": "ffc7",
	"./icon-info.svg": "d399",
	"./icon-lock.svg": "85d1",
	"./icons/account_balance_24dp.svg": "ac2c",
	"./icons/add-disabled.svg": "7450",
	"./icons/add.svg": "76a4",
	"./icons/alert-icon.svg": "dd45",
	"./icons/arrow-down.svg": "c874",
	"./icons/arrow-left.svg": "ac3b",
	"./icons/arrow-white.svg": "0e6c",
	"./icons/arrow_disabled_left.svg": "b1e9",
	"./icons/arrow_disabled_right.svg": "e7d5",
	"./icons/arrow_enabled_left.svg": "cf74",
	"./icons/arrow_enabled_right.svg": "1841",
	"./icons/assignment-ind.svg": "aac4",
	"./icons/bank-icon.svg": "69d2",
	"./icons/better-v.svg": "13eb",
	"./icons/blacktrash.svg": "5222",
	"./icons/broken-link-icon.svg": "27f8",
	"./icons/challenge-action.svg": "409f",
	"./icons/chat_icon_secondary.svg": "ee6b",
	"./icons/chat_icon_small.svg": "bafd",
	"./icons/chat_icon_small_teriatry.svg": "0278",
	"./icons/chat_icon_small_white.svg": "e27d",
	"./icons/chat_icon_teriatry.svg": "e1cf",
	"./icons/check-light-blue.svg": "1918",
	"./icons/check-list.svg": "54a4",
	"./icons/check_mark.svg": "734d",
	"./icons/checkmark-blue-little.svg": "a1be",
	"./icons/close-fat.svg": "fd8e",
	"./icons/close-white.svg": "72e4",
	"./icons/close.svg": "8b1b",
	"./icons/comment.svg": "c47d",
	"./icons/credit-card-icon-disabled.svg": "fbbb",
	"./icons/credit-card-icon.svg": "ceab",
	"./icons/credit-card-outline.svg": "0535",
	"./icons/credit-card.svg": "98dc",
	"./icons/credit_card_24dp.svg": "6a6f",
	"./icons/edit-prediction.svg": "844e",
	"./icons/edits-exclude.svg": "7f39",
	"./icons/edits-move.svg": "6a40",
	"./icons/edits-sub-category.svg": "08e2",
	"./icons/edits-trash.svg": "dd9b",
	"./icons/event.svg": "e5b3",
	"./icons/exclamation-mark.svg": "379f",
	"./icons/exclemation-mark-blue.svg": "702f",
	"./icons/exclemation-mark-coral.svg": "8205",
	"./icons/exclemation-mark-gray.svg": "a2a7",
	"./icons/exclemation-mark-red.svg": "839f",
	"./icons/exclemation-mark-yellow.svg": "d94a",
	"./icons/expand-arrow-down-medium-disabled.svg": "f37d",
	"./icons/expand-arrow-down-medium.svg": "a22a",
	"./icons/expand-arrow-down-small-disabled.svg": "4c2c",
	"./icons/expand-arrow-down-small.svg": "d9f8",
	"./icons/flag-grey.svg": "1d60",
	"./icons/flag.svg": "c26e",
	"./icons/graph-bars.svg": "d17d",
	"./icons/graph-line.svg": "43c8",
	"./icons/gray-pencil.svg": "cffd",
	"./icons/gray-trash.svg": "0fbf",
	"./icons/group-5.svg": "c92d",
	"./icons/hands_raised.png": "3668",
	"./icons/heart-icon.svg": "267f",
	"./icons/heart.svg": "7d16",
	"./icons/ic-close.svg": "d41d",
	"./icons/icon-check-blue.svg": "8894",
	"./icons/icon-lock-gray.svg": "2202",
	"./icons/icon_add_member.svg": "a2bb",
	"./icons/icon_edit.svg": "b919",
	"./icons/icon_left_arrow.svg": "2951",
	"./icons/icon_supermarket.svg": "6682",
	"./icons/info-icon-blue.svg": "75fa",
	"./icons/left-triangle.svg": "3eed",
	"./icons/light-three-dots.svg": "0c5d",
	"./icons/location-marker.svg": "dee5",
	"./icons/lock-blue.svg": "b47b",
	"./icons/lock-grey.svg": "a7d1",
	"./icons/lock-outline.svg": "5994",
	"./icons/menu-white.svg": "f800",
	"./icons/menu.svg": "d17f",
	"./icons/modal-close-blue.svg": "0158",
	"./icons/modal-close-mustard.svg": "3d49",
	"./icons/mode-edit.svg": "af9c",
	"./icons/next-month-triangle.svg": "d602",
	"./icons/notice-gray.svg": "c521",
	"./icons/notice-green.png": "4986",
	"./icons/pending.svg": "e25a",
	"./icons/phone-vector.svg": "df8d",
	"./icons/present.svg": "4577",
	"./icons/previous-month-triangle.svg": "916e",
	"./icons/redtrash.svg": "7fc3",
	"./icons/remove.svg": "5088",
	"./icons/right-triangle.svg": "b750",
	"./icons/sad-smiley-blue.svg": "494e",
	"./icons/sad-smiley-grey.svg": "74f1",
	"./icons/search-grey.svg": "9d9a",
	"./icons/search-vector.svg": "0c46",
	"./icons/search.svg": "d103",
	"./icons/small_check.svg": "b78e",
	"./icons/smiling-smiley-blue.svg": "aa83",
	"./icons/smiling-smiley-grey.svg": "1d59",
	"./icons/success-icon.svg": "13a1",
	"./icons/three-dots.svg": "0960",
	"./icons/thumbs-down.svg": "9a65",
	"./icons/thumbs-up.svg": "fe9c",
	"./icons/tooltip_chat_icon.svg": "62ba",
	"./icons/trash.svg": "af22",
	"./icons/unknown-error.png": "c2bd",
	"./icons/v-blue.svg": "3fe6",
	"./icons/v-outline.svg": "bf62",
	"./icons/v-white.svg": "7dc7",
	"./icons/v.svg": "347a",
	"./icons/verified.svg": "256c",
	"./icons/vertical-three-dots.svg": "6bbd",
	"./icons/wallet-vector.svg": "d460",
	"./icons/warning-icon.svg": "209f",
	"./insights/car.svg": "1b3a",
	"./insights/demographic-info.svg": "7d46",
	"./insights/donation.svg": "908a",
	"./insights/expense_decreased.svg": "adf1",
	"./insights/expense_increased.svg": "1248",
	"./insights/fees_insights.svg": "3a27",
	"./insights/first_cf_tips_header.svg": "71cf",
	"./insights/fixed.svg": "6f58",
	"./insights/groceries-benchmark-icons.svg": "dbfa",
	"./insights/groceries-benchmark.svg": "4d21",
	"./insights/income_decreased.svg": "509c",
	"./insights/income_increased.svg": "90d9",
	"./insights/leisure.svg": "3847",
	"./insights/might-be-new-fixed-expense.svg": "aff9",
	"./insights/might-be-new-fixed-income.svg": "2f0d",
	"./insights/negative_balance.svg": "9d47",
	"./insights/other.svg": "1b60",
	"./insights/pets.svg": "dd99",
	"./insights/pharma.svg": "aee2",
	"./insights/rolling-credit-comments.png": "5f51",
	"./insights/rolling-credit.svg": "6e12",
	"./insights/shopping.svg": "5c97",
	"./insights/take-outs.svg": "8c44",
	"./insights/tourism.svg": "c0ed",
	"./insights/tracking_insight.svg": "0983",
	"./insights/transport.svg": "364b",
	"./insights/zero-balance-expense.svg": "ed65",
	"./insights/zero-balance-income.svg": "4462",
	"./intercom_chat_icon.svg": "3529",
	"./introduction/emun.png": "a467",
	"./introduction/first-step.png": "1b2d",
	"./introduction/graph-intro.svg": "e296",
	"./introduction/group-3@3x.png": "83ce",
	"./introduction/intro_image.png": "740e",
	"./introduction/intro_image_new.png": "d1db",
	"./introduction/intro_image_new_smaller.png": "f0cf",
	"./introduction/kikar-header.svg": "d417",
	"./introduction/positive-cash.svg": "9b10",
	"./introduction/test-1-image@3x.png": "da941",
	"./introduction/test-image-2@3x.png": "40d9",
	"./investigation_vis.svg": "94c1",
	"./invite-member-message.png": "4ec4",
	"./invite-member-top.png": "f841",
	"./invite-member.svg": "7006",
	"./leumi_riseup_friends.svg": "6830",
	"./lock.svg": "3c1a",
	"./lock_done.svg": "981f",
	"./lock_green.png": "b31d",
	"./lock_icon.svg": "c790",
	"./logo-vertical.svg": "ff18",
	"./mid-month/confetti.svg": "8738",
	"./mid-month/left.svg": "37ea",
	"./mid-month/month-sticker.svg": "72bc",
	"./mid-month/next-arrow-cool.svg": "b8cc",
	"./mid-month/real-price-hashtag.svg": "ec64",
	"./mid-month/restart.svg": "3d9f",
	"./mid-month/right-blue.svg": "97e9",
	"./mid-month/right.svg": "0cee",
	"./mid-month/star-green.svg": "c654",
	"./mid-month/star-red.svg": "6991",
	"./mid-month/testimonials.png": "45b39",
	"./nav/Hamburger.svg": "827b",
	"./nav/ambassadors.svg": "f261",
	"./nav/chat.svg": "3101",
	"./nav/exit.svg": "b8b9",
	"./nav/fb.svg": "a607",
	"./nav/help.svg": "8d0d",
	"./nav/left-arrow.svg": "8a70",
	"./nav/share.svg": "f723",
	"./nav/sun.svg": "d57e",
	"./nav/trophy.svg": "6124",
	"./no-overdraft.png": "be60",
	"./onboarding-discount.png": "aec4",
	"./onboarding/Ball-0.9s-200px.svg": "51b5",
	"./onboarding/Boti.svg": "60ba",
	"./onboarding/bank-connected-big.svg": "60d0",
	"./onboarding/bank_square_bottom.svg": "43cf",
	"./onboarding/bank_square_top.svg": "fbfb",
	"./onboarding/big-icon-alert.svg": "2212",
	"./onboarding/big-icon-eclipse.svg": "b9e9",
	"./onboarding/big-icon-rising.svg": "ad0d",
	"./onboarding/big-icon-unsupported.svg": "1d78",
	"./onboarding/cards_square_bottom.svg": "3c0a",
	"./onboarding/cards_square_top.svg": "7658",
	"./onboarding/cashflow-loader/arrows.svg": "f6d2",
	"./onboarding/cashflow-loader/pyramid.svg": "5605",
	"./onboarding/cashflow-loader/sun.svg": "a393",
	"./onboarding/cashflow-loader/wave.svg": "25d7",
	"./onboarding/creds-coffee-cup.svg": "2355",
	"./onboarding/emun_black_white.svg": "31c7",
	"./onboarding/expenses_square_bottom.svg": "7cfe",
	"./onboarding/expenses_square_top.svg": "a51a",
	"./onboarding/header-bank-square-bottom.svg": "9de1",
	"./onboarding/icons/arrow-up.svg": "554d",
	"./onboarding/icons/bank-icon-disabled.svg": "f27d",
	"./onboarding/icons/bank-icon.svg": "50eb",
	"./onboarding/icons/big-icon-discount-incomplete.svg": "08ef",
	"./onboarding/icons/big-icon-unsupported.svg": "0f46",
	"./onboarding/icons/check-blue.svg": "a443",
	"./onboarding/icons/ic-chevron-down-black.svg": "cbc8",
	"./onboarding/icons/ic-chevron-up-black.svg": "6455",
	"./onboarding/icons/icon-add.svg": "13d9",
	"./onboarding/icons/icon-lock.svg": "29a8",
	"./onboarding/icons/icon-remove.svg": "7c07",
	"./onboarding/icons/icon-small-check.svg": "a155",
	"./onboarding/icons/icon-small-lock.svg": "7e2b",
	"./onboarding/icons/left-arrow.svg": "192b",
	"./onboarding/icons/no-icon.svg": "7775",
	"./onboarding/icons/pending-joint.svg": "9ba0",
	"./onboarding/icons/play-btn.svg": "d2b8",
	"./onboarding/icons/privacy.svg": "a581",
	"./onboarding/icons/shield-icon.svg": "edff",
	"./onboarding/icons/shield-square.svg": "d07d",
	"./onboarding/icons/shield_square.svg": "5b95",
	"./onboarding/icons/wait-icon.svg": "6146",
	"./onboarding/icons/whatsapp.svg": "d7c5",
	"./onboarding/incomes_bottom_square.svg": "ea54",
	"./onboarding/incomes_square_top.svg": "f568",
	"./onboarding/iso-logo.svg": "a6f8",
	"./onboarding/mti_logo.svg": "975a",
	"./onboarding/past_month_balance.svg": "8324",
	"./onboarding/safe.svg": "b269",
	"./onboarding/safe2.svg": "1227",
	"./onboarding/safe3.svg": "e75c",
	"./onboarding/secVidImg.png": "7c77",
	"./onboarding/security-logos.svg": "ad21",
	"./onboarding/security-top-image.svg": "a068",
	"./onboarding/spinner-big.svg": "0868",
	"./onboarding/trust-logos.svg": "2c27",
	"./open-link-button.svg": "3d3a",
	"./oval@3x.png": "e8fe",
	"./past-editable-month/arrow-left.svg": "6dab",
	"./past-editable-month/end-of-month-left.svg": "1217",
	"./past-editable-month/end-of-month-right.svg": "036b",
	"./pc-no-support-icon.svg": "0fbfb",
	"./pencil.svg": "33bf",
	"./pending-icon.svg": "4a6d",
	"./promotions/21-days/21-days-promo-header.png": "10cf",
	"./promotions/21-days/21-days-promo-welcome-header.png": "a659",
	"./promotions/aleph/aleph-header.svg": "d63e",
	"./promotions/alljobs/alljobs-2-mo-image.png": "2c25",
	"./promotions/alljobs/alljobs-3-mo-image.png": "d0cf",
	"./promotions/alljobs/alljobs-welcome.png": "70f2",
	"./promotions/ashmoret/ashmoret_header.svg": "dfe5",
	"./promotions/bat-yam/batyam-header.png": "bf73",
	"./promotions/bat-yam/batyam-header.svg": "3b73",
	"./promotions/discount/discont_welcome_header.png": "9d3e",
	"./promotions/discount/discount-header.svg": "991b",
	"./promotions/discount/discount-riseup.svg": "1b12",
	"./promotions/friends/friends-header.png": "59bc",
	"./promotions/friends/friends-welcome-header.png": "3305",
	"./promotions/generic-signup-header.png": "5919",
	"./promotions/generic-welcome-header.png": "d909",
	"./promotions/harel/harel-header.png": "81ed",
	"./promotions/harel/harel-welcome-header.png": "f09a",
	"./promotions/hayanshuf/hayanshuf-header.svg": "fdab",
	"./promotions/isracard/isracard-header.svg": "66f9",
	"./promotions/isracard/isracard-welcome-header.png": "0c0e",
	"./promotions/jerusalem/jerusalem-header.svg": "0e09",
	"./promotions/netafim/netafim_header.png": "93f3",
	"./promotions/nevo/nevo_header.svg": "5a39",
	"./promotions/new-credit/new-credit.jpg": "1954",
	"./promotions/new-credit/newcredit_header.svg": "32c8",
	"./promotions/promo-popup-image.svg": "e98c",
	"./promotions/promotion-expired.svg": "1a43",
	"./promotions/tarya/tarya-header.svg": "7ba2",
	"./promotions/yahav/yahav-signup.png": "3c54",
	"./promotions/yahav/yahav-welcome.svg": "7742",
	"./rainbow.svg": "0bee",
	"./remove-disabled.svg": "c046",
	"./riseup-logo.svg": "33a8",
	"./riseup_logo.svg": "c442",
	"./rolling-credit-vis.svg": "e227",
	"./round-header-background.svg": "3dab",
	"./saving-zone/no-funds-header-image.svg": "d304",
	"./share_black_icon.svg": "1dca",
	"./share_white_icon.svg": "7d84",
	"./story-backgrounds/cashflowy.png": "a8c6",
	"./story-backgrounds/default.png": "83f3",
	"./story-backgrounds/expensive-day.png": "6bcd",
	"./story-backgrounds/pool.png": "bc1d",
	"./story-backgrounds/real-price-hashtag.svg": "3df7",
	"./story-backgrounds/vacation.png": "e4b2",
	"./story-backgrounds/wedding.png": "40ef",
	"./story-backgrounds/worth-it.png": "df86",
	"./subdirectory-arrow-left@3x.png": "a3d3",
	"./subscription/discount.svg": "2a4d",
	"./subscription/edit_icon.svg": "f7e75",
	"./subscription/flow.png": "f279",
	"./subscription/header.svg": "148f",
	"./subscription/oval-green.png": "47dd",
	"./subscription/oval-mustard.png": "96e3",
	"./subscription/personal-info.png": "ea56",
	"./subscription/riseup-icon.png": "84fc",
	"./subscription/subscribe_header.svg": "89a2",
	"./subscription/success.png": "3caf",
	"./subscription/thnaks_for_subscribing_header.svg": "5497",
	"./sun.svg": "3f73b",
	"./sun2.svg": "bd6c",
	"./testpng.png": "d76b",
	"./trusted.png": "cff1",
	"./whatsapp-icon.svg": "d117",
	"./whatsapp-optin.jpg": "2a32",
	"./whatsapp.svg": "3357",
	"./wine-and-dine/CX.png": "6be4",
	"./wine-and-dine/cover-image@3x.png": "c158",
	"./wine-and-dine/financial_advice_faces@2x.png": "d3db",
	"./wine-and-dine/money-question@3x.png": "e268"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";